/**
 * Canonical "a folder landed on the canvas" bucketing: one section per
 * top-level folder, subfolders flattened into their top-level ancestor.
 * Lifted out of `useCanvasCanvasDropTarget.ts` so the OS drop and the
 * Insert menu's folder picker produce the identical layout.
 */
import type { FolderUploadTree } from "@/utils/traverseDataTransferItems";

/** Horizontal step between consecutive folder sections. */
export const CANVAS_FOLDER_SECTION_OFFSET_X = 700;

export function bucketFolderTreeIntoSections(
  tree: FolderUploadTree,
): { folderName: string; files: File[] }[] {
  const buckets = new Map<string, File[]>();
  for (const { file, relativePath } of tree.files) {
    const topSegment = relativePath.split("/")[0];
    if (!topSegment) continue;
    const arr = buckets.get(topSegment) ?? [];
    arr.push(file);
    buckets.set(topSegment, arr);
  }
  return Array.from(buckets.entries(), ([folderName, files]) => ({
    folderName,
    files,
  }));
}
